import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function TestPage() {
  useEffect(() => {
    document.title = '廿日市の塾 定期テスト対策｜学習塾NICK｜廿日市市中学生の成績アップ・内申点対策';

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', '廿日市の塾・学習塾NICKの定期テスト対策ページ。廿日市市の中学生の成績アップ・内申点対策を徹底サポート。廿日市市内各中学校の出題傾向を分析し、テスト2週間前から集中対策。無料体験受付中。');
    setMeta('keywords', '廿日市 定期テスト対策,廿日市 中学生 成績アップ,廿日市 内申点対策,廿日市 塾 テスト,廿日市 中学生 塾,学習塾NICK 定期テスト');
    setMeta('og:title', '廿日市の塾 定期テスト対策｜学習塾NICK', true);
    setMeta('og:description', '廿日市市の中学生の定期テスト対策は学習塾NICKへ。廿日市市内各中学校の出題傾向を分析した集中対策で成績アップ・内申点アップを実現。', true);
    setMeta('og:url', `${import.meta.env.VITE_SITE_URL}/test`, true);
    setMeta('twitter:title', '廿日市の塾 定期テスト対策｜学習塾NICK');
    setMeta('twitter:description', '廿日市市の中学生の定期テスト対策は学習塾NICKへ。各中学校の出題傾向を分析した集中対策で成績アップを実現。');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL}/test`);

    // Schema.org JSON-LD
    const schemaId = 'schema-test-page';
    let schemaEl = document.getElementById(schemaId) as HTMLScriptElement | null;
    if (!schemaEl) {
      schemaEl = document.createElement('script');
      schemaEl.id = schemaId;
      schemaEl.type = 'application/ld+json';
      document.head.appendChild(schemaEl);
    }
    schemaEl.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "廿日市の塾 定期テスト対策｜学習塾NICK",
      "description": "廿日市市の中学生の定期テスト対策は学習塾NICKへ。廿日市市内各中学校の出題傾向を分析した集中対策で成績アップ・内申点アップを実現。",
      "url": `${import.meta.env.VITE_SITE_URL}/test`,
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "ホーム", "item": `${import.meta.env.VITE_SITE_URL}/` },
          { "@type": "ListItem", "position": 2, "name": "定期テスト対策", "item": `${import.meta.env.VITE_SITE_URL}/test` }
        ]
      },
      "mainEntity": {
        "@type": "Course",
        "name": "廿日市 定期テスト対策コース",
        "description": "廿日市市内の各中学校の出題傾向を分析した定期テスト対策。テスト2週間前から集中対策を実施し、成績アップ・内申点アップを実現。",
        "provider": {
          "@type": "Organization",
          "name": "学習塾NICK",
          "url": `${import.meta.env.VITE_SITE_URL}/`
        },
        "educationalLevel": "中学生",
        "teaches": ["定期テスト対策", "内申点アップ", "成績アップ", "提出物管理", "学習習慣定着"]
      }
    });

    return () => {
      document.title = '廿日市の塾なら学習塾NICK｜廿日市市の中学生塾・成績アップ・高校受験対策';
      if (canonical) canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL}/`);
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  const problems = [
    {
      icon: 'ri-time-line',
      title: '勉強時間は取っているのに点数が伸びない',
      description: '毎日勉強しているのに、テストで思うような点数が取れない。努力が結果に結びつかず、モチベーションが下がってしまう。'
    },
    {
      icon: 'ri-question-line',
      title: 'どこから手をつければいいかわからない',
      description: 'テスト範囲が広すぎて、何から勉強すればいいのか分からない。計画的に学習を進められない。'
    },
    {
      icon: 'ri-book-line',
      title: '提出物が期限に間に合わない',
      description: '学校のワークや課題が溜まってしまい、テスト前に慌てて終わらせる。内申点に影響が出てしまう。'
    },
    {
      icon: 'ri-file-list-line',
      title: '暗記科目が覚えられない',
      description: '理科や社会の暗記が苦手で、覚えてもすぐに忘れてしまう。効率的な暗記方法が分からない。'
    }
  ];

  const solutions = [
    {
      title: '学校別の出題傾向分析',
      description: '廿日市市内の各中学校の過去の定期テスト問題を分析し、学校ごとの出題傾向を把握。よく出る問題パターンを重点的に対策します。各学校の先生の特徴も理解しているため、的確な予想問題で演習できます。',
      icon: 'ri-line-chart-line',
      image: 'https://public.readdy.ai/ai/img_res/e85044bae9ad70fccc4557c0e3ce4aa6.jpg'
    },
    {
      title: '2週間前からの集中対策',
      description: '定期テスト2週間前から、通常授業を定期テスト対策モードに切り替え。テスト範囲を徹底的に復習し、予想問題演習を繰り返します。弱点を洗い出し、確実に得点できるまで指導します。',
      icon: 'ri-calendar-check-line',
      image: 'https://readdy.ai/api/search-image?query=japanese%20students%20preparing%20for%20exams%20intensive%20study%20session%20modern%20classroom%20focused%20atmosphere%20educational%20guidance%20clean%20minimalist%20design%20warm%20lighting&width=600&height=400&seq=test002&orientation=landscape'
    },
    {
      title: '提出物の徹底管理',
      description: '学校のワークや課題の進捗を毎回チェック。計画的に進められるようスケジュール管理をサポートします。提出物の質も確認し、内申点アップにつながる丁寧な仕上げを指導します。',
      icon: 'ri-task-line',
      image: 'https://readdy.ai/api/search-image?query=japanese%20teacher%20checking%20student%20homework%20and%20assignments%20organized%20study%20materials%20modern%20educational%20environment%20clean%20design%20natural%20lighting%20peaceful%20atmosphere&width=600&height=400&seq=test003&orientation=landscape'
    },
    {
      title: '効率的な暗記法の指導',
      description: '単なる丸暗記ではなく、理解を伴った記憶定着を目指します。語呂合わせ、図表の活用、関連付けなど、科目ごとに最適な暗記法を指導。反復演習で長期記憶に定着させます。',
      icon: 'ri-brain-line',
      image: 'https://readdy.ai/api/search-image?query=japanese%20students%20using%20memory%20techniques%20and%20study%20methods%20colorful%20study%20materials%20modern%20classroom%20creative%20learning%20atmosphere%20clean%20design%20natural%20lighting&width=600&height=400&seq=test004&orientation=landscape'
    },
    {
      title: '科目別の対策授業',
      description: '数学は計算ミスを防ぐ解法パターンの習得、英語は文法と長文読解の強化、国語は記述問題の書き方指導、理科・社会は重要ポイントの整理と演習。各科目の特性に合わせた対策を実施します。',
      icon: 'ri-book-2-line',
      image: 'https://readdy.ai/api/search-image?query=japanese%20students%20studying%20different%20subjects%20textbooks%20and%20notebooks%20organized%20modern%20classroom%20educational%20environment%20clean%20design%20natural%20lighting%20peaceful%20atmosphere&width=600&height=400&seq=test005&orientation=landscape'
    },
    {
      title: '質問対応と個別フォロー',
      description: 'わからない問題はその場で質問できる環境を整備。授業外でも自習室で質問対応を行い、疑問を残さず理解を深めます。一人ひとりの理解度に合わせた個別フォローで、確実な得点力を養成します。',
      icon: 'ri-question-answer-line',
      image: 'https://readdy.ai/api/search-image?query=japanese%20teacher%20helping%20student%20one%20on%20one%20tutoring%20personalized%20learning%20modern%20classroom%20warm%20atmosphere%20educational%20guidance%20clean%20design%20natural%20lighting&width=600&height=400&seq=test006&orientation=landscape'
    }
  ];

  const internalPoints = [
    {
      title: '定期テストの点数',
      weight: '約70%',
      description: '5教科の定期テスト合計点が内申点の大部分を占めます。毎回のテストで確実に点数を積み重ねることが重要です。'
    },
    {
      title: '提出物',
      weight: '約20%',
      description: 'ワークや課題の提出状況と内容の質が評価されます。期限を守り、丁寧に仕上げることが内申点アップの鍵です。'
    },
    {
      title: '授業態度',
      weight: '約10%',
      description: '授業への参加姿勢、発言、ノートの取り方なども評価対象。積極的な姿勢が評価されます。'
    }
  ];

  const results = [
    { student: '中2 Aさん', subject: '数学', before: '45点', after: '82点', improvement: '+37点' },
    { student: '中3 Bくん', subject: '英語', before: '52点', after: '88点', improvement: '+36点' },
    { student: '中1 Cさん', subject: '5教科', before: '298点', after: '412点', improvement: '+114点' },
    { student: '中2 Dくん', subject: '理科', before: '38点', after: '76点', improvement: '+38点' },
    { student: '中3 Eさん', subject: '国語', before: '55点', after: '85点', improvement: '+30点' },
    { student: '中2 Fくん', subject: '社会', before: '48点', after: '82点', improvement: '+34点' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-32 bg-gradient-to-br from-[#4a90e2]/10 via-white to-[#4a90e2]/5">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-[#1a2332] mb-6">
              定期テスト対策
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              <strong>廿日市市</strong>の学習塾NICKでは、各中学校の出題傾向を分析した<strong>定期テスト対策</strong>で、確実な<strong>成績アップ</strong>を実現します。<strong>内申点対策</strong>にも力を入れ、<strong>高校受験</strong>に向けた基礎を固めます。
            </p>
          </div>
        </section>

        {/* Problems Section */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-4 text-center">
              定期テストで点数が伸びない原因
            </h2>
            <p className="text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
              <strong>廿日市市</strong>の<strong>中学生</strong>から多く寄せられる<strong>定期テスト</strong>に関するお悩みです
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {problems.map((problem, index) => (
                <div
                  key={index}
                  className="bg-[#f8f9fa] rounded-3xl p-8 hover:shadow-xl transition-all duration-300"
                >
                  <div className="w-16 h-16 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center mb-6">
                    <i className={`${problem.icon} text-3xl text-[#4a90e2]`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-4">
                    {problem.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {problem.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-16 bg-[#4a90e2]/5 rounded-3xl p-10 text-center">
              <h3 className="text-2xl font-bold text-[#1a2332] mb-4">
                これらの悩みは、正しい学習方法と計画的な対策で解決できます
              </h3>
              <p className="text-gray-600 leading-relaxed max-w-3xl mx-auto">
                学習塾NICKでは、<strong>廿日市市</strong>の各中学校の特性を理解した講師が、一人ひとりに合わせた<strong>定期テスト対策</strong>を行います。<strong>少人数指導</strong>と<strong>個別指導</strong>で、確実な<strong>成績アップ</strong>をサポートします。
              </p>
            </div>
          </div>
        </section>

        {/* Solutions Section */}
        <section className="py-24 bg-[#f8f9fa]">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-4 text-center">
              学習塾NICKの定期テスト対策
            </h2>
            <p className="text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
              <strong>廿日市市大野</strong>で20年以上の実績を持つ学習塾NICKの具体的な対策方法
            </p>

            <div className="space-y-16">
              {solutions.map((solution, index) => (
                <div
                  key={index}
                  className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                    index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                  }`}
                >
                  <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                    <div className="w-16 h-16 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center mb-6">
                      <i className={`${solution.icon} text-3xl text-[#4a90e2]`}></i>
                    </div>
                    <h3 className="text-2xl md:text-3xl font-bold text-[#1a2332] mb-6">
                      {solution.title}
                    </h3>
                    <p className="text-gray-600 text-lg leading-relaxed">
                      {solution.description}
                    </p>
                  </div>

                  <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                    <img
                      src={solution.image}
                      alt={solution.title}
                      className="w-full h-[400px] object-cover rounded-3xl shadow-xl"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Internal Points Section */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-4 text-center">
              内申点アップの考え方
            </h2>
            <p className="text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
              <strong>高校受験</strong>で重要な<strong>内申点</strong>。その仕組みを理解し、戦略的に対策することが合格への近道です。
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              {internalPoints.map((point, index) => (
                <div
                  key={index}
                  className="bg-[#f8f9fa] rounded-3xl p-8 text-center hover:shadow-xl transition-all duration-300"
                >
                  <div className="text-5xl font-bold text-[#4a90e2] mb-4">
                    {point.weight}
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-4">
                    {point.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {point.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="bg-[#1a2332] rounded-3xl p-10 text-white">
              <h3 className="text-2xl font-bold mb-6 text-center">
                学習塾NICKの内申点対策
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h4 className="font-bold mb-4 flex items-center gap-3">
                    <i className="ri-check-double-line text-2xl text-[#4a90e2]"></i>
                    定期テスト対策
                  </h4>
                  <p className="text-white/80 leading-relaxed mb-6">
                    各中学校の出題傾向を分析し、2週間前から集中対策。予想問題演習で確実に得点力を養成します。
                  </p>

                  <h4 className="font-bold mb-4 flex items-center gap-3">
                    <i className="ri-check-double-line text-2xl text-[#4a90e2]"></i>
                    提出物管理
                  </h4>
                  <p className="text-white/80 leading-relaxed">
                    ワークや課題の進捗を毎回チェック。期限を守り、質の高い提出物を完成させるサポートを行います。
                  </p>
                </div>

                <div>
                  <h4 className="font-bold mb-4 flex items-center gap-3">
                    <i className="ri-check-double-line text-2xl text-[#4a90e2]"></i>
                    学習習慣の定着
                  </h4>
                  <p className="text-white/80 leading-relaxed mb-6">
                    自習室の活用や家庭学習の計画立案をサポート。継続的な学習習慣を身につけます。
                  </p>

                  <h4 className="font-bold mb-4 flex items-center gap-3">
                    <i className="ri-check-double-line text-2xl text-[#4a90e2]"></i>
                    保護者との連携
                  </h4>
                  <p className="text-white/80 leading-relaxed">
                    定期的な面談で学習状況を共有。ご家庭と連携しながら、お子様の成長をサポートします。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Results Section */}
        <section className="py-24 bg-[#f8f9fa]">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-4 text-center">
              定期テスト成績アップ実績
            </h2>
            <p className="text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
              <strong>廿日市市</strong>の学習塾NICKで<strong>定期テスト対策</strong>を受けた生徒たちの成果
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {results.map((result, index) => (
                <div
                  key={index}
                  className="bg-white rounded-3xl p-8 hover:shadow-xl transition-all duration-300"
                >
                  <div className="flex items-center justify-between mb-4">
                    <p className="text-sm font-semibold text-gray-600">
                      {result.student}
                    </p>
                    <span className="bg-[#4a90e2]/10 text-[#4a90e2] px-4 py-1 rounded-full text-sm font-semibold">
                      {result.subject}
                    </span>
                  </div>

                  <div className="flex items-center justify-center gap-4 mb-6">
                    <div className="text-center">
                      <p className="text-sm text-gray-600 mb-1">入塾前</p>
                      <p className="text-3xl font-bold text-gray-400">
                        {result.before}
                      </p>
                    </div>

                    <i className="ri-arrow-right-line text-3xl text-[#4a90e2]"></i>

                    <div className="text-center">
                      <p className="text-sm text-gray-600 mb-1">入塾後</p>
                      <p className="text-3xl font-bold text-[#4a90e2]">
                        {result.after}
                      </p>
                    </div>
                  </div>

                  <div className="bg-[#4a90e2] text-white text-center py-3 rounded-2xl">
                    <p className="text-2xl font-bold">{result.improvement}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-16 text-center">
              <p className="text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
                <strong>廿日市市大野</strong>の学習塾NICKでは、<strong>少人数指導</strong>と<strong>個別指導</strong>で一人ひとりに合わせた<strong>定期テスト対策</strong>を実施。多くの<strong>中学生</strong>が<strong>成績アップ</strong>を実現しています。
              </p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 bg-[#1a2332]">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              定期テスト対策は学習塾NICKにお任せください
            </h2>
            <p className="text-white/80 text-lg mb-10 leading-relaxed">
              <strong>廿日市市</strong>の学習塾NICKでは、<strong>無料体験授業</strong>を随時受け付けております。<strong>定期テスト対策</strong>の具体的な方法や、<strong>内申点アップ</strong>の戦略について詳しくご説明いたします。<strong>廿日市市</strong>、<strong>宮島</strong>、<strong>阿品</strong>、<strong>大竹市</strong>など周辺地域からもお気軽にお越しください。
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/trial#trial-form-section"
                className="bg-[#4a90e2] text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-[#3a7bc8] transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                無料体験に申し込む
                <i className="ri-arrow-right-line text-xl"></i>
              </Link>
              <a
                href="tel:0829-78-1638"
                className="bg-white text-[#1a2332] px-10 py-5 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                電話で問い合わせる
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
